import style from '../portfolio-items.module.css'
import Carousel from './embla-carousel/volleygrad-embla.jsx'
import Portfolio from '../../../main/portfolio.jsx'
import ContactForm from '../../../main/contactForm.jsx'
import HireUs from '../../../forIndustrial/hireUs.jsx'

const OPTIONS = {}

export default function Volleygrad(props) {
    return (
        <div className={style.wrapper}>
            <div className={style.container}>
                <h1><span style={{color: '#ff8c00'}}>Солнечная станция</span><br /> для СУОЦ «Волей-Град» в Анапе</h1>
                <Carousel options={OPTIONS} />
                <div className={style.description}>
                    <div className={style.tasks}>
                        <h6>Задача:</h6>
                        <p>Снизить энергопотребление зданий СУОЦ «Волей-Град» в Анапе.</p>
                    </div>
                    <div className={style.specification}>
                        <div сlassName={style.info}>
                            <p><strong>Заказчик: </strong>ООО «Юнигрин Инжиниринг» (ГК «Хевел»).</p>
                            <p><strong>Конечный заказчик: </strong>ООО «СпортСтройСервис».</p>
                            <p><strong>Дата: </strong>август 2025 г.</p>
                            <p><strong>Срок выполнения: </strong>25 рабочих дней.</p>
                            <h3 className={style.results}>Результаты работ:</h3>
                            <ul>
                                <li>Произведена модернизация схемы электроснабжения СУОЦ «Волей-Град» с установкой фотоэлектрической системы.</li>
                                <li>Расчетная выработка СЭС составляет 262 МВт·ч в год.</li>
                                <li>Экономия составляет 3 380 000₽ в год.</li>
                            </ul>
                        </div>
                        <div className={style.solution}>
                            <h3>Решения для проекта:</h3>
                            <ul>
                                <li>Смонтирована крышная СЭС установленной мощностью 196,32 кВт.</li>
                                <li>Применены фотоэлектрические солнечные модули марки «Хевел» мощностью 315 Вт, сетевые солнечные инверторы SG20KTL мощностью 20 кВт (1 шт.), SG12KTL мощностью 12 кВт (2 шт.), SG33CX мощностью 33 кВт (4 шт.).</li>
                                <li>Установлена система мониторинга солнечной станции.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <HireUs />
            <Portfolio />
            <div style={{height: '2rem'}}></div>
            <ContactForm />
        </div>
    )
}